import * as React from "react";
import styled from "styled-components";

import PopoverContainer from "./PopoverContainer";
import Icon from "../Icon";

interface Props {
  text: string;
  className?: string;
}

class Hint extends React.PureComponent<Props> {
  public render() {
    const { text, className } = this.props;
    return (
      <PopoverContainer
        render={({ left, top, onOpen, onClose }) => {
          const onCloseDelayed = () => onClose({ delay: 200 });
          return (
            <Tip onMouseEnter={onOpen} onMouseLeave={onCloseDelayed} style={{ left, top }}>
              {text}
            </Tip>
          );
        }}
      >
        {({ setRef, onOpen, onClose, isOpen }) => {
          const onOpenDelayed = () => onOpen({ delay: 100 });
          const onCloseDelayed = () => onClose({ delay: 300 });
          return (
            <IconWrapper
              innerRef={setRef}
              onMouseEnter={onOpenDelayed}
              onMouseLeave={onCloseDelayed}
              onTouchEnd={isOpen ? onCloseDelayed : onOpenDelayed}
              className={className}
            >
              <HintIcon name="wt-icon-infomation" />
            </IconWrapper>
          );
        }}
      </PopoverContainer>
    );
  }
}

const Tip = styled.div`
  position: absolute;
  transform: translate(22px, -50%);
  max-width: 210px;
  padding: 6px 12px;
  background: rgba(0, 0, 0, 0.4);
  color: white;
  font-size: 12px;
  line-height: 1.6;
  border-radius: 10px;
`;

const IconWrapper = styled.span`
  display: inline-block;
`;

const HintIcon = styled(Icon)`
  display: block;
  text-indent: 1px;
`;

export default Hint;



// WEBPACK FOOTER //
// ./frontend/src/common/components/popover/Hint.tsx